import React from 'react';

import { AiIcon } from '../AiIcon/AiIcon';
import { OcTooltip } from '../OcWidget/components/Shared/OcTooltip';
import { AiBadge, AiBadgeContainer, AssistantName, Avatar,AvatarContainer,HeaderContainer } from './AiMessageHeader.styled';

export interface AiMessageHeaderProps {
  /** Name of the AI assistant */
  assistantName: string;
  /** Optional custom avatar URL */
  avatarUrl?: string;
  /** Additional CSS class names */
  className?: string;
}

const AI_TOOLTIP_CONTENT = (
  <div>
    This is an AI-powered chatbot. It uses artificial intelligence to understand your questions and provide helpful answers. It references the content within this site that you have access to view and may also use the LLM&apos;s training data when no relevant community content is available.
    <br />
    <br />
    AI can make mistakes, so be sure to double-check its responses.
  </div>
);

/**
 * AiMessageHeader Component
 * 
 * Header displayed above AI assistant messages showing avatar and name.
 * Falls back to sparkle icon if no custom avatar is provided.
 * 
 * Features:
 * - Custom avatar support via URL
 * - Sparkle icon fallback
 * - "AI" badge indicator with tooltip
 * - Responsive font sizing
 * 
 * @example
 * ```tsx
 * <AiMessageHeader 
 *   assistantName="Community Assistant"
 *   avatarUrl="https://example.com/avatar.png"
 * />
 * ```
 */
export const AiMessageHeader: React.FC<AiMessageHeaderProps> = ({
  assistantName,
  avatarUrl,
  className = '',
}) => {
  return (
    <HeaderContainer className={className}>
      <AvatarContainer>
      {/* Avatar or sparkle icon */}
      {avatarUrl ? (
        <Avatar src={avatarUrl} alt={assistantName} />
      ) : (
        <AiIcon height={18} />
      )}

      {/* Assistant name */}
      <AssistantName>{assistantName}</AssistantName>
      </AvatarContainer>

      {/* AI badge with tooltip */}
      <AiBadgeContainer>
        <OcTooltip 
          overlay={AI_TOOLTIP_CONTENT}
          placement="bottom"
          title="Information about AI assistant"
        >
          <AiBadge>AI</AiBadge>
        </OcTooltip>
      </AiBadgeContainer>
    </HeaderContainer>
  );
};

export default AiMessageHeader;
